import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { userProfile } from '../../assets/images'
import {
    IconBrandFacebook,
    IconBrandLinkedin,
    IconBrandPaypalFilled,
    IconBrandTwitter,
    IconBrandVimeo,
    IconCircleXFilled,
    IconDeviceDesktop,
    IconDeviceMobile,
    IconCirclePlus,
    IconDeviceLaptop,
    IconBrandInstagram,
} from '@tabler/icons-react'

export default function Profile() {

    const Settings = () => {
        return (
            <>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        Profile Photo
                    </div>
                    <div className='flex gap-15'>
                        <div>
                            <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover border-2 border-border' />
                        </div>
                        <div className='flex flex-col'>
                            <div>
                                Upload your photo.
                            </div>
                            <div className='mb-15'>
                                <i>Image should be at least 140px x 140px</i>
                            </div>
                            <div className='mt-auto'>
                                <label className='btn btn-secondary cursor-pointer'>
                                    <input type='file' className='hidden' />
                                    Upload Photo
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        Basic Information
                    </div>
                    <div className='grid md:grid-cols-2 gap-x-30 gap-y-20'>
                        <div className='flex flex-col gap-20'>
                            <div className='form-group'>
                                <input type='text' id='firstName' name='firstName' placeholder='First Name' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='lastName' name='lastName' placeholder='Last Name' />
                            </div>
                            <div className='flex flex-wrap gap-15'>
                                <label className='cus-radio' htmlFor="male">
                                    <input type="radio" id="male" name="gender" defaultChecked />
                                    <span className="checkmark"></span>
                                    Male
                                </label>
                                <label className='cus-radio' htmlFor="female">
                                    <input type="radio" id="female" name="gender" />
                                    <span className="checkmark"></span>
                                    Female
                                </label>
                                <label className='cus-radio' htmlFor="other">
                                    <input type="radio" id="other" name="gender" />
                                    <span className="checkmark"></span>
                                    Other
                                </label>
                            </div>
                            <div className='form-group flex'>
                                <input type='date' id='birthDate' name='birthDate' placeholder='Birthdate' className='grow' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='websiteUrl' name='websiteUrl' placeholder='http://' />
                            </div>
                        </div>
                        <div className='flex flex-col gap-20'>
                            <div className='form-group'>
                                <input type='text' id='addressLine1' name='addressLine1' placeholder='Address Line 1' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='addressLine2' name='addressLine2' placeholder='Address Line 2' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='city' name='city' placeholder='City' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='state' name='state' placeholder='State/Province' />
                            </div>
                            <div className='form-group'>
                                <select name="selectCountry" id="selectCountry">
                                    <option value="blogCategory">-- Select Country --</option>
                                    <option value="webDesign">India</option>
                                    <option value="photography">United States</option>
                                    <option value="technology">United Kingdom</option>
                                    <option value="lifestyle">United Arab Emirates</option>
                                    <option value="sports">Ukraine</option>
                                </select>
                            </div>
                        </div>
                        <div className='flex flex-wrap gap-10'>
                            <button className='btn btn-primary'>
                                Update
                            </button>
                            <button className='btn btn-outline-secondary'>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        Account Data
                    </div>
                    <div className='grid md:grid-cols-2 gap-x-30 gap-y-20'>
                        <div className='flex flex-col gap-20'>
                            <div className='form-group'>
                                <input type='text' id='userName' name='userName' value="alizeethomas" placeholder='Username' disabled />
                            </div>
                            <div className='form-group'>
                                <input type='email' id='email' name='email' placeholder='Email' />
                            </div>
                            <div className='form-group'>
                                <input type='text' id='domain' name='domain' placeholder='Domain' />
                            </div>
                        </div>
                        <div className='flex flex-col gap-20'>
                            <div className='form-group'>
                                <input type='password' id='currentPassword' name='currentPassword' placeholder='Current Password' />
                            </div>
                            <div className='form-group'>
                                <input type='password' id='newPassword' name='newPassword' placeholder='New Password' />
                            </div>
                            <div className='form-group'>
                                <input type='password' id='newConfirmPassword' name='newConfirmPassword' placeholder='Confirm New Password' />
                            </div>
                        </div>
                        <div className='flex flex-wrap gap-10'>
                            <button className='btn btn-primary'>
                                Update
                            </button>
                            <button className='btn btn-outline-secondary'>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        General Information
                    </div>
                    <div className='grid md:grid-cols-2 gap-x-30 gap-y-20'>
                        <div className='flex flex-col gap-20'>
                            <div className='form-group'>
                                <input type='number' id='number' name='number' placeholder='Phone Number' />
                            </div>
                            <div className='form-group'>
                                <select name="selectLanguage" id="selectLanguage">
                                    <option value="blogCategory">-- Select Language --</option>
                                    <option value="webDesign">Hindi</option>
                                    <option value="photography">English</option>
                                    <option value="technology">Urdu</option>
                                </select>
                            </div>
                            <div className='form-group'>
                                <select name="selectTimezone" id="selectTimezone">
                                    <option value="blogCategory">-- Select Timezone --</option>
                                    <option value="webDesign">UTC-5</option>
                                    <option value="photography">UTC-12</option>
                                    <option value="technology">UTC</option>
                                </select>
                            </div>
                            <div>
                                <p className='font-semibold mb-10'>
                                    Date Format
                                </p>
                                <div className='flex flex-wrap gap-15'>
                                    <label className='cus-radio' htmlFor="dateType1">
                                        <input type="radio" id="dateType1" name="dateType" />
                                        <span className="checkmark"></span>
                                        May 18, 2018
                                    </label>
                                    <label className='cus-radio' htmlFor="dateType2">
                                        <input type="radio" id="dateType2" name="dateType" />
                                        <span className="checkmark"></span>
                                        2018, May, 18
                                    </label>
                                    <label className='cus-radio' htmlFor="dateType3">
                                        <input type="radio" id="dateType3" name="dateType" defaultChecked />
                                        <span className="checkmark"></span>
                                        2018-03-10
                                    </label>
                                    <label className='cus-radio' htmlFor="dateType4">
                                        <input type="radio" id="dateType4" name="dateType" />
                                        <span className="checkmark"></span>
                                        02/09/2018
                                    </label>
                                    <label className='cus-radio' htmlFor="dateType5">
                                        <input type="radio" id="dateType5" name="dateType" />
                                        <span className="checkmark"></span>
                                        10/05/2018
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col gap-20'>
                            <div>
                                <p className='font-semibold mb-10'>
                                    Email from Lucid
                                </p>
                                <p>
                                    I'd like to receive the following emails:
                                </p>
                            </div>
                            <label className='cus-checkbox text-text-primary flex items-center gap-10'>
                                <input type='checkbox' defaultChecked />
                                <span className='checkmark'></span>
                                Weekly account summary
                            </label>
                            <label className='cus-checkbox text-text-primary flex items-center gap-10'>
                                <input type='checkbox' />
                                <span className='checkmark'></span>
                                Campaign reports
                            </label>
                            <label className='cus-checkbox text-text-primary flex items-center gap-10'>
                                <input type='checkbox' defaultChecked />
                                <span className='checkmark'></span>
                                Promotional news such as offers or discounts
                            </label>
                            <label className='cus-checkbox text-text-primary flex items-center gap-10'>
                                <input type='checkbox' defaultChecked />
                                <span className='checkmark'></span>
                                Tips for campaign setup, growth and client success stories
                            </label>
                        </div>
                        <div className='flex flex-wrap gap-10'>
                            <button className='btn btn-primary'>
                                Update
                            </button>
                            <button className='btn btn-outline-secondary'>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const Billings = () => {
        return (
            <>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        Payment Method
                    </div>
                    <div className='flex flex-wrap gap-15 items-start justify-between'>
                        <div>
                            <div className='flex items-center gap-5 text-[20px]/[24px] font-medium mb-10'>
                                <IconBrandPaypalFilled />
                                PayPal ****2222
                            </div>
                            <div>
                                Next billing charged $29
                            </div>
                            <div className='text-text-secondary'>
                                <i>Autopay on May 12, 2018</i>
                            </div>
                            <button className='flex items-center gap-5 mt-10 text-blue transition-all duration-300 hover:text-blue-100'>
                                <IconCirclePlus className='w-[18px] h-[18px]' />
                                Add Payment Info
                            </button>
                        </div>
                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                            Edit Payment Info
                        </button>
                    </div>
                </div>
                <div className='mt-40'>
                    <div className='text-[16px]/[19.2px] font-medium mb-10'>
                        Billing History
                    </div>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[600px]'>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    <div className='text-[18px]/[21.6px] font-medium mb-5'>
                                        Basic Plan &nbsp; #LA35628
                                    </div>
                                    <div className='text-text-secondary'>
                                        Charged at April 17, 2018
                                    </div>
                                </td>
                                <td className='p-3 border-t border-border text-[18px]/[21.6px]'>
                                    $29
                                </td>
                                <td align='right' className='p-3 border-t border-border'>
                                    <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                        View
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    <div className='text-[18px]/[21.6px] font-medium mb-5'>
                                        Pro Plan &nbsp; #LA3599
                                    </div>
                                    <div className='text-text-secondary'>
                                        Charged at March 18, 2018
                                    </div>
                                </td>
                                <td className='p-3 border-t border-border text-[18px]/[21.6px]'>
                                    $59
                                </td>
                                <td align='right' className='p-3 border-t border-border'>
                                    <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                        View
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    <div className='text-[18px]/[21.6px] font-medium mb-5'>
                                        Platinum Plan &nbsp; #LA1245
                                    </div>
                                    <div className='text-text-secondary'>
                                        Charged at Feb 02, 2018
                                    </div>
                                </td>
                                <td className='p-3 border-t border-border text-[18px]/[21.6px]'>
                                    $89
                                </td>
                                <td align='right' className='p-3 border-t border-border'>
                                    <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                        View
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div className='flex flex-wrap gap-10 mt-20'>
                    <button className='btn btn-primary'>
                        Update
                    </button>
                    <button className='btn btn-outline-secondary'>
                        Cancel
                    </button>
                </div>
            </>
        )
    }

    const Preferences = () => {
        return (
            <>
                <div className='mt-40 grid lg:grid-cols-2 lg:gap-50 gap-30'>
                    <div>
                        <div className='text-[16px]/[19.2px] font-medium mb-10'>
                            Your Login Sessions
                        </div>
                        <div>
                            <div className='flex items-center gap-15 justify-between py-30 border-b border-border last:border-none'>
                                <div className='flex gap-10 items-start'>
                                    <IconDeviceLaptop className='w-[30px] h-[30px] stroke-[1.5]' />
                                    <div>
                                        <p className='text-[16px]/[19.2px] font-medium mb-10'>
                                            Mac - New York, United States
                                        </p>
                                        <p className='text-text-secondary'>
                                            Chrome - <span className='text-success'>Active Now</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center gap-15 justify-between py-30 border-b border-border last:border-none'>
                                <div className='flex gap-10 items-start'>
                                    <IconDeviceDesktop className='w-[30px] h-[30px] stroke-[1.5]' />
                                    <div>
                                        <p className='text-[16px]/[19.2px] font-medium mb-10'>
                                            Windows 10 - New York, United States
                                        </p>
                                        <p className='text-text-secondary'>
                                            Firefox - about an hour ago
                                        </p>
                                    </div>
                                </div>
                                <button>
                                    <IconCircleXFilled className='w-[20px] h-[20px] text-danger' />
                                </button>
                            </div>
                            <div className='flex items-center gap-15 justify-between py-30 border-b border-border last:border-none'>
                                <div className='flex gap-10 items-start'>
                                    <IconDeviceMobile className='w-[30px] h-[30px] stroke-[1.5]' />
                                    <div>
                                        <p className='text-[16px]/[19.2px] font-medium mb-10'>
                                            Android - New York, United States
                                        </p>
                                        <p className='text-text-secondary'>
                                            Android Browser - yesterday
                                        </p>
                                    </div>
                                </div>
                                <button>
                                    <IconCircleXFilled className='w-[20px] h-[20px] text-danger' />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='text-[16px]/[19.2px] font-medium mb-10'>
                            Connected Social Media
                        </div>
                        <div>
                            <div className='flex gap-15 items-start py-15 border-b border-border last:border-none'>
                                <IconBrandFacebook className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[18px]/[21.6px] font-medium mb-5'>
                                        FaceBook
                                    </p>
                                    <div className='flex gap-15 flex-wrap'>
                                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                            View Permissions
                                        </button>
                                        <button className='text-danger transition-all duration-300 hover:text-danger-100'>
                                            Revoke Access
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex gap-15 items-start py-15 border-b border-border last:border-none'>
                                <IconBrandTwitter className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[18px]/[21.6px] font-medium mb-5'>
                                        FaceBook
                                    </p>
                                    <div className='flex gap-15 flex-wrap'>
                                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                            View Permissions
                                        </button>
                                        <button className='text-danger transition-all duration-300 hover:text-danger-100'>
                                            Revoke Access
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex gap-15 items-start py-15 border-b border-border last:border-none'>
                                <IconBrandInstagram className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[18px]/[21.6px] font-medium mb-5'>
                                        FaceBook
                                    </p>
                                    <div className='flex gap-15 flex-wrap'>
                                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                            View Permissions
                                        </button>
                                        <button className='text-danger transition-all duration-300 hover:text-danger-100'>
                                            Revoke Access
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex gap-15 items-start py-15 border-b border-border last:border-none'>
                                <IconBrandLinkedin className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[18px]/[21.6px] font-medium mb-5'>
                                        FaceBook
                                    </p>
                                    <div className='flex gap-15 flex-wrap'>
                                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                            View Permissions
                                        </button>
                                        <button className='text-danger transition-all duration-300 hover:text-danger-100'>
                                            Revoke Access
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex gap-15 items-start py-15 border-b border-border last:border-none'>
                                <IconBrandVimeo className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[18px]/[21.6px] font-medium mb-5'>
                                        FaceBook
                                    </p>
                                    <div className='flex gap-15 flex-wrap'>
                                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                            View Permissions
                                        </button>
                                        <button className='text-danger transition-all duration-300 hover:text-danger-100'>
                                            Revoke Access
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <Breadcrumb title="User Profile" path="Pages / User Profile" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <Tabs className="custom-tab1">
                    <TabList>
                        <Tab>
                            Settings
                        </Tab>
                        <Tab>
                            Billings
                        </Tab>
                        <Tab>
                            Preferences
                        </Tab>
                    </TabList>
                    <TabPanel>
                        <Settings />
                    </TabPanel>
                    <TabPanel>
                        <Billings />
                    </TabPanel>
                    <TabPanel>
                        <Preferences />
                    </TabPanel>
                </Tabs>
            </div>
        </>
    )
}
